import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SpaceShape } from 'venuescanner-js/react/shapes';
import { subscribe } from 'venuescanner-js/react/helpers';
import SrpContainer from '../../containers/SrpContainer';
// import { spaceContext } from 'venuescanner-js/vanilla/components/spaceContext'

const getLinkQueryString = ({ location, query }) => {
  const { search, pathname } = location;
  const { city_slug, event_type } = query;
  const queries = {};
  if (city_slug) queries.location = city_slug;
  if (event_type?.value) queries.tag = event_type.value;
  if (Object.keys(queries).length) {
    return `?${Object.entries(queries)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')}`;
  }
  // const pathComponents = pathname.split('/')
  // const eventType = event_type.value || (pathComponents.length < 3 ? undefined : pathComponents[pathComponents.length - 1])
  // if (search.length > 1 && eventType) {
  // if (eventType) {
  //   return search + `&eventType=${eventType}`
  // }

  // if (eventType) {
  //   return `?eventType=${eventType}`
  // }
  return search;
};

// TODO: TRACK AND REMOVE ga
export const SpaceLink = ({
  space,
  _ga,
  children,
  qs = '',
  isAdmin,
  superLoggedIn,
  ...otherProps
}) => {
  const handleClick = useCallback(() => {
    if (!window || !document) return;
    window.history.replaceState(
      { srpClickedSpace: space.id },
      null,
      document.location.href,
    );
  }, [space]);
  const contextMenu = e => {
    e.preventDefault();
    if (isAdmin || superLoggedIn) {
      if (window && window.spaceContext) {
        window.spaceContext({ contextEvent: e, hashcode: space.hashcode });
      }
      // spaceContext({ contextEvent: e, hashcode: space.hashcode })
    }
  };

  return (
    <a
      href={space.url + qs}
      onClick={handleClick}
      onContextMenu={contextMenu}
      rel='noopener noreferrer'
      target='_blank'
      {...otherProps}>
      {children}
    </a>
  );
};

SpaceLink.propTypes = {
  space: SpaceShape.isRequired,
  ga: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  qs: PropTypes.string,
  isAdmin: PropTypes.bool,
  superLoggedIn: PropTypes.bool,
};

const SpaceLinkWithFilters = subscribe({ SrpContainer })(
  ({ srpContainer: { state }, ...props }) => {
    const linkQs = useMemo(() => getLinkQueryString(state), [state]);
    return <SpaceLink {...props} qs={linkQs} />;
  },
);

const SpaceLinkWrapper = ({ includeSrpFilters = false, ...props }) =>
  includeSrpFilters ? (
    <SpaceLinkWithFilters {...props} />
  ) : (
    <SpaceLink {...props} />
  );

SpaceLinkWrapper.propTypes = {
  includeSrpFilters: PropTypes.bool,
};

export default SpaceLinkWrapper;
// const SpaceLinkWrapper = () => <div>Spacelink</div>
// export const SpaceLink = () => <div>Spacelink</div>
// export default SpaceLinkWrapper
